<div>
  <div class="mb-2" *ngIf="section == 'IsMain'">
    <!--Register-->
    <div class="py-2" dir="ltr">
      <div class="">
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-center">
      <div class="button-container shadow-lg rounded-4 p-4" style="background-color: #f8f8f8">
        <!-- [class.disabled]="!globals.isChecked" -->
        <!-- (click)="isMainScreen = false; isregister = false;"  routerLink="/booking-login" -->
        <div class="button-item d-none">
          <p>
            <img src="assets/img/Shift Rotation OPD.png" alt="Online OPD Appointment" />
          </p>
          <h2>
            <b>Online OPD<br />Appointment</b>
          </h2>
        </div>
        <div class="button-item d-none">
          <p>
            <img src="assets/img/On Call Vertual Consultation.png" alt="Virtual Consultation" />
          </p>
          <h2><b>Virtual Consultation</b></h2>
        </div>

        <div class="button-item" routerLink="/session/onlineyoga">
          <p>
            <img src="assets/img/Online Yoga.png" alt="Virtual Consultation" />
          </p>
          <h2><b>Online Yoga</b></h2>
        </div>

        <div class="button-item" routerLink="/session/booking-login/booking-login-register">
          <p>
            <img src="assets/img/Healthcare Sign IPD.png" alt="Online Admissions" />
          </p>
          <h2>
            <b>Online<br />Admissions</b>
          </h2>
        </div>
        <!-- <img src="assets/img/11047742.jpg" alt="Online Admissions"> -->
        <div class="button-item" routerLink="/session/booking/checkavailability">
          <p>
            <img src="assets/img/Hospital Bed Bed Availability.png" alt="Check Admission Availability" />
          </p>
          <h2>
            <b>Check<br />Admission<br />Availability</b>
          </h2>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="section == 'Checkavailability'">
    <div class="ttm-bgcolor-whiteecolor mt-1 fontsizeandfamilyCalibri">
      <!--Courses landing-->
      <div class="course-wrap">
        <div class="banner-wrap bg-secondary py-4">
          <div class="container">
            <div class="banner-content">
              <div class="row mb-2">
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-md-5 text-right mt-2">
                      <strong class="mr-2">Check-in Date</strong>
                    </div>
                    <div class="col-md-6 text-left mt-2">
                      <div class="input-group">
                        <input matInput [matDatepicker]="picker" [(ngModel)]="checkinDate" [min]="Today"
                          [max]="maxDate()" class="form-control w-auto" [matDatepickerFilter]="disableSundays"
                          (dateChange)="bedData = [];" />
                        <span class="input-group-append">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-md-2 text-right mt-2">
                      <strong id="lblDuration">Duration</strong>
                    </div>
                    <div class="col-md-6 text-left mt-2">
                      <select class="form-control" [(ngModel)]="AdmissionDuration">
                        <option *ngFor="let duration of AdmissionDurationRange" [value]="duration.Description">
                          {{ duration.Description }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center mt-3 mb-3">
                  <button type="button" class="btn btn-success px-4 py-2" (click)="CheckAvailability()">
                    <i [ngClass]=" isInProgress ? 'spinner-border spinner-border-sm mr-1' : 'fa fa-search mr-1'"
                      aria-hidden="true"></i>
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="courses-content-wrap mt-3 fontsizeandfamilyCalibri">
          <div class="container" *ngIf="errorMessage == '' && bedData.length > 0">
            <div class="degree-wrap">
              <div class="row justify-content-center">
                <ng-container *ngFor="let room of bedData">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-3 grid-b-space" (click)="GetSelectedRow(room)">
                    <div class="card shadow-box border">
                      <figure class="imghvr-zoom-in">
                        <a class="p-cursor">
                          <img class="img-fluid" alt="example-image" [src]="room.ImgURL" />
                        </a>
                      </figure>
                      <!-- routerLink="/session/booking-login" -->
                      <div class="card-body">
                        <div class="sec-content text-left">
                          <strong> {{ room["Healing retreat"] }}</strong><br />
                          <!-- <strong>Vaccant Bed Count:- </strong
                          ><label>{{ room[headers[3]] }} </label><br /> -->
                          <strong>Vacant Bed Count:- </strong><label>{{ GetlowestNumber(room) }} </label><br />
                          <strong>Rate:- </strong><label> {{ room[headers[1]] }} </label>
                          <button *ngIf="room['Healing retreat'] == SelectedButtonRow['Healing retreat']" type="button"
                            class="btn btn-secondary ml-3" routerLink="/session/booking-login/booking-login-register">
                            Book Now
                          </button>
                        </div>
                      </div>
                      <div class="card-custom-footer">
                        <div class="course-footer-descp">
                          <span class="footer-shape d-flex align-items-center justify-content-start"><i
                              class="fa fa-certificate mx-3" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <h1 class="text-danger" *ngIf="errorMessage != '' && BookingCount == -1">
            {{ errorMessage }}
          </h1>
          <h1 class="text-danger" *ngIf="errorMessage != '' && BookingCount >= 40">
            {{ errorMessage }}
          </h1>
          <h1 class="text-danger" *ngIf="Nobedforthisrange && bedData.length == 0">
            {{ errorMessage }}
          </h1>
          <!--Recommended Booking Dates-->
          <!-- <div class="courses-grid-slider py-4" dir="ltr" *ngIf="RecommendedBookingDatesList.length > 0">
        <div class="container">
          <div class="sec-title mrgn-b-2">
            <h4 class="font-weight-light"><span class="font-2x">{{'Recommended Booking Dates'|translate}}</span></h4>
          </div>
          <div class="row mb-4" *ngIf="RecommendedBookingDatesList.length > 0">
            <div class="col-12">
              <div class="d-flex overflow-auto flex-nowrap pb-2 px-2">
                <ng-container *ngFor="let row of RecommendedBookingDatesList">
                  <div class="flex-shrink-0" style="margin-right: 12px;">
                    <button type="button" class="btn" style="min-width: 160px;" class="btn-outline-primary">
                      {{row.StartDate | date: 'dd-MM-yyyy'}}
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div> -->

          <!-- <div class="courses-grid-slider py-4" dir="ltr" *ngIf="RecommendedBookingDatesList.length > 0">
            <div class="container">
              <div class="sec-title mrgn-b-2">
                <h4 class="font-weight-light">
                  <span class="font-2x">{{ 'Recommended Booking Dates' | translate }}</span>
                </h4>
              </div>
              <div class="row mb-4">
                <div class="col-12 d-flex align-items-center">
                  <div class="arrow-icon" (click)="scrollLeft()"><i class="fa-lg fa-solid fa-chevron-left"></i></div>
                  <div #scrollContainer class="date-scroll-container d-flex overflow-auto flex-nowrap pb-2 px-2"
                    style="gap: 12px;">
                    <ng-container *ngFor="let row of RecommendedBookingDatesList">
                      <div class="flex-shrink-0">
                        <button type="button" class="btn btn-outline-dark" (click)="GetRecommendedDateBooking(row)"
                          style="min-width: 160px; height: 80px; border-radius: 12px;">
                          <div class="fw-bold fontsizeandfamilyCalibri"><strong>{{ row.StartDate | date: 'EEE'
                              }}</strong>
                          </div>
                          <div class="fontsizeandfamilyCalibri"><strong>{{ row.StartDate | date: 'dd MMM' }}</strong>
                          </div>
                        </button>
                      </div>
                    </ng-container>
                  </div>
                  <div class="arrow-icon" (click)="scrollRight()"><i class="fa-lg fa-solid fa-chevron-right"></i></div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>